import { FormModelFieldSubForm, getSubformPath, type FormModelField } from '@ikegps/core-shared';
import { T, Translate } from '../../i18n';
import { FormDesignerPalette } from '../form.designer/form.palette';

export function fieldLabel(field: FormModelField): string {
	if (field.isStatusField) {
		return Translate(T.COLLECTION_MIGRATE_FORM_STATUS_LABEL);
	}

	return field.displayName;
}

export function fieldMeta(field: FormModelField): string {
	if (field.isStatusField) {
		return Translate(T.COLLECTION_MIGRATE_FORM_STATUS_LABEL);
	}

	if (FormModelFieldSubForm.isSubForm(field)) {
		return Translate(T.COLLECTION_MIGRATE_FORM_GROUP_FIELD_COUNT, { count: field.fields.length });
	}

	return FormDesignerPalette.translate(field.type);
}

export function fieldGroupPath(field: FormModelField): string {
	const path = getSubformPath(field);

	return path.length > 0
		? path.map((subform) => subform.displayName).join(' › ')
		: Translate(T.COLLECTION_MIGRATE_FORM_ROOT_GROUP);
}

export function fieldOptionLabel(field: FormModelField): string {
	return `${fieldLabel(field)} · ${fieldGroupPath(field)}`;
}
